<script setup>
import { computed, ref, watch } from "vue";
import { renderQuillComment } from "@/utils/renderQuillComment";
const props = defineProps({ content: { type: String, default: "" } });
const rendered = ref(null);
const hasMarkup = computed(() => /<\/?[a-z][^>]*>/i.test(props.content));
watch(() => props.content, () => { rendered.value = null; });
const prepare = quill => { rendered.value = renderQuillComment(quill, props.content, { stripWhiteBackground: true }); };
</script>

<template>
  <div class="social-fund-rich-text">
    <p v-if="!hasMarkup" class="social-fund-rich-text__plain">{{ content }}</p>
    <QuillEditor v-else-if="rendered === null" content-type="html" theme="" :read-only="true" @ready="prepare" />
    <div v-else class="social-fund-rich-text__content"><div class="ql-editor" v-html="rendered" /></div>
  </div>
</template>

<style scoped>
.social-fund-rich-text__plain { white-space: pre-wrap; margin: 0; }
.social-fund-rich-text { min-width: 0; overflow-wrap: anywhere; margin: 8px 0; }
.social-fund-rich-text__content { font: inherit; }
:deep(.ql-container) { font: inherit; }
:deep(.ql-editor) { padding: 0; font: inherit; overflow-wrap: anywhere; }
:deep(.ql-editor p) { margin: 0; }
</style>
